import React, { useState, useEffect } from 'react';
import { 
  Crown, Trophy, Star, Award, Users, Target,
  TrendingUp, DollarSign, Calendar, BarChart3,
  Filter, Search, ChevronDown, Zap, Medal
} from 'lucide-react';

// Import the new banner component
import PlayerRingOfFameBanner from './PlayerRingOfFameBanner';
import HighestPaidPlayerMemorial from './HighestPaidPlayerMemorial';
import PositionRingOfFame from './PositionRingOfFame';
import Top50HighestPaidPlayers from './Top50HighestPaidPlayers';
import Top10PlayersByPosition from './Top10PlayersByPosition';

const PlayerRingOfFame = ({ draftData, loading, error }) => {
  if (loading) {
    return (
      <div className="space-y-8">
        {/* Add the banner even during loading */}
        <PlayerRingOfFameBanner />
        
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-purple-500"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-8">
        {/* Add the banner even during error state */}
        <PlayerRingOfFameBanner />
        
        <div className="bg-red-50 border border-red-200 rounded-2xl p-8">
          <h3 className="text-lg font-medium text-red-800 mb-2">Error Loading Data</h3>
          <p className="text-red-600">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {/* Player Ring of Fame Banner */}
      <PlayerRingOfFameBanner />

      {/* Highest Paid Player Memorial */}
      <HighestPaidPlayerMemorial 
        draftData={draftData}
        loading={loading}
        error={error}
      />

      {/* Position Ring of Fame */}
      <PositionRingOfFame 
        draftData={draftData}
        loading={loading}
        error={error}
      />

      {/* Top 50 Highest Paid Players */}
      <Top50HighestPaidPlayers
        draftData={draftData}
        loading={loading}
        error={error}
      />

      {/* Top 10 Players by Position */}
      <Top10PlayersByPosition
        draftData={draftData}
        loading={loading}
        error={error}
      />
    </div>
  );
};

export default PlayerRingOfFame;